import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config/apiConfig'; // Ajusta la ruta a tu config

// --- ESTILOS LOCALES ---
const LocalStyles = function () {
    return (
        <style>{`
            .rounded-xl { border-radius: 1.25rem !important; }
            .rounded-lg { border-radius: 0.75rem !important; }
            .badge-soft-success { background-color: #e6fcf5; color: #087f5b; border: none; }
            .badge-soft-secondary { background-color: #f1f3f5; color: #495057; border: none; }
            .btn-icon { 
                width: 38px; 
                height: 38px; 
                display: inline-flex; 
                align-items: center; 
                justify-content: center; 
                border: none; 
                background: #f8f9fa; 
                border-radius: 50%; 
                transition: all 0.2s;
                cursor: pointer;
            }
            .btn-icon:hover { 
                background: #e9ecef; 
                transform: scale(1.1);
            }
            .modal-backdrop-blur { background-color: rgba(0,0,0,0.6); backdrop-filter: blur(4px); }
            .shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); }
        `}</style>
    );
};

const AdministradorRepartidores = function (props) {
    const negocioId = props.negocioId || 1;

    const [repartidores, setRepartidores] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [repartidorToEdit, setRepartidorToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [form, setForm] = useState({ nombre: '', chat_id: '', activo: 1 });
    const [isLoading, setIsLoading] = useState(false);

    // --- CARGAR DATOS ---
    const cargarRepartidores = async function () {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(config.api_url + "/api/repartidores", {
                headers: { 'token': token }
            });
            const data = await response.json();
            setRepartidores(Array.isArray(data) ? data : (data.data || []));
        } catch (err) {
            toast.error("Error al cargar repartidores");
        }
    };

    // --- GUARDAR / ACTUALIZAR ---
    const handleGuardar = async function (e) {
        if (e) e.preventDefault();
        if (!form.nombre || !form.chat_id) return toast.warning("Completa los campos obligatorios");

        const url = '/api/repartidores/guardar';
        const token = localStorage.getItem("token");

        setIsLoading(true);
        try {
            const response = await fetch(config.api_url + url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({
                    id: form.id,
                    nombre: form.nombre,
                    chat_id: form.chat_id,
                    negocio_id: negocioId,
                    activo: form.activo ? 1 : 0
                })
            });

            const resData = await response.json();
            if (resData.res) {
                toast.success(resData.msg || "Guardado con éxito");
                setIsModalOpen(false);
                cargarRepartidores();
            } else {
                throw new Error(resData.msg);
            }
        } catch (err) {
            toast.error("Error: " + err.message);
        } finally {
            setIsLoading(false);
        }
    };

    // --- ELIMINAR (Lógica de desactivación) ---
    const handleEliminar = async function (id, nombre) {
        if (!window.confirm("¿Estás seguro de eliminar a " + nombre + "?")) return;

        const token = localStorage.getItem("token");
        try {
            const response = await fetch(config.api_url + "/api/repartidores/eliminar/" + id, {
                method: 'DELETE',
                headers: { 'token': token }
            });
            const resData = await response.json();
            if (resData.res) {
                toast.success("Repartidor eliminado correctamente");
                cargarRepartidores();
            } else {
                toast.error("No se pudo eliminar");
            }
        } catch (err) {
            toast.error("Error de conexión");
        }
    };

    useEffect(function () {
        cargarRepartidores();
    }, []);

    const abrirModal = function (repartidor) {
        if (repartidor) {
            setRepartidorToEdit(repartidor);
            setForm(repartidor);
        } else {
            setRepartidorToEdit(null);
            setForm({ nombre: '', chat_id: '', activo: 1 });
        }
        setIsModalOpen(true);
    };

    const filtered = repartidores.filter(function (r) {
        var nom = r.nombre || "";
        return nom.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
    });

    return (
        <div className="bg-light min-vh-100 py-5 px-3">
            <LocalStyles />
            <ToastContainer position="bottom-center" />

            <div className="container" style={{ maxWidth: '900px' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h2 className="font-weight-bold text-dark m-0">Repartidores</h2>
                        <p className="text-muted mb-0">Gestión de equipo de entregas</p>
                    </div>
                    <button className="btn btn-primary btn-lg rounded-pill shadow px-4" onClick={function () { abrirModal(null); }}>
                        <i className="fas fa-plus mr-2"></i> Nuevo Repartidor
                    </button>
                </div>

                <div className="card border-0 shadow-sm rounded-xl overflow-hidden">
                    <div className="card-header bg-white border-0 pt-4 px-4">
                        <div className="input-group bg-light rounded-pill px-3 py-1 border shadow-sm">
                            <div className="input-group-prepend border-0 bg-transparent">
                                <span className="input-group-text bg-transparent border-0 text-muted"><i className="fas fa-search"></i></span>
                            </div>
                            <input
                                type="text" className="form-control bg-transparent border-0 shadow-none"
                                placeholder="Escribe el nombre del repartidor..." value={searchTerm}
                                onChange={function (e) { setSearchTerm(e.target.value) }}
                            />
                        </div>
                    </div>

                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light text-muted small text-uppercase font-weight-bold">
                                    <tr>
                                        <th className="border-0 px-4 py-3">Nombre</th>
                                        <th className="border-0 py-3">Telegram Chat ID</th>
                                        <th className="border-0 py-3 text-center">Estado</th>
                                        <th className="border-0 px-4 py-3 text-right">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.map(function (r) {
                                        return (
                                            <tr key={r.id}>
                                                <td className="px-4 py-3 font-weight-bold text-dark">{r.nombre}</td>
                                                <td className="py-3"><code>{r.chat_id}</code></td>
                                                <td className="py-3 text-center">
                                                    <span className={"badge px-3 py-2 rounded-pill " + (r.activo ? "badge-soft-success" : "badge-soft-secondary")}>
                                                        {r.activo ? '● Visible' : '● Oculto'}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 text-right">
                                                    <button 
                                                        className="btn-icon mr-2" 
                                                        title="Editar"
                                                        onClick={function () { abrirModal(r); }}
                                                    >
                                                        <i className="fas fa-pen text-primary"></i>
                                                    </button>
                                                    <button 
                                                        className="btn-icon" 
                                                        title="Eliminar"
                                                        onClick={function () { handleEliminar(r.id, r.nombre); }}
                                                    >
                                                        <i className="fas fa-trash text-danger"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {filtered.length === 0 && (
                                <div className="text-center py-5">
                                    <p className="text-muted font-italic">No se encontraron repartidores registrados.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL */}
            {isModalOpen && (
                <div className="modal fade show d-block modal-backdrop-blur" style={{ zIndex: 1050 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-2xl rounded-xl overflow-hidden">
                            <div className="modal-header bg-white border-0 pt-4 px-4">
                                <h5 className="font-weight-bold m-0">{repartidorToEdit ? 'Editar Repartidor' : 'Nuevo Repartidor'}</h5>
                                <button type="button" className="close" onClick={function () { setIsModalOpen(false) }}>&times;</button>
                            </div>
                            <form onSubmit={handleGuardar}>
                                <div className="modal-body p-4">
                                    <div className="form-group mb-4">
                                        <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Nombre del Repartidor</label>
                                        <input
                                            type="text" className="form-control form-control-lg border-light bg-light rounded-lg shadow-none"
                                            value={form.nombre} onChange={function (e) { setForm({ ...form, nombre: e.target.value }) }}
                                            placeholder="Ej. Juan Carlos"
                                        />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Chat ID Telegram</label>
                                        <input
                                            type="text" className="form-control form-control-lg border-light bg-light rounded-lg shadow-none"
                                            value={form.chat_id} onChange={function (e) { setForm({ ...form, chat_id: e.target.value }) }}
                                            placeholder="Ej. 12345678"
                                        />
                                    </div>
                                    <div className="bg-light p-3 rounded-lg">
                                        <div className="custom-control custom-switch">
                                            <input
                                                type="checkbox" className="custom-control-input" id="swActivoRep"
                                                checked={form.activo === 1}
                                                onChange={function (e) { setForm({ ...form, activo: e.target.checked ? 1 : 0 }) }}
                                            />
                                            <label className="custom-control-label font-weight-bold text-dark" htmlFor="swActivoRep" style={{cursor: 'pointer'}}>
                                                Disponible para recibir pedidos
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 p-4">
                                    <button type="button" className="btn btn-link text-muted shadow-none" onClick={function () { setIsModalOpen(false) }}>Cancelar</button>
                                    <button type="submit" className="btn btn-primary btn-lg rounded-pill px-5 shadow-sm" disabled={isLoading}>
                                        {isLoading ? 'Guardando...' : 'Guardar Repartidor'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdministradorRepartidores;